
import { Component, Vue } from 'vue-property-decorator'
import { Form as ElForm } from 'element-ui'   // eslint-disable-line
import { MediaService } from '@/services/index'
import { isValidScore, isValidEmail  } from '@/common/utils'
import { CodeToText } from '@/common/area_data'
import { AppModule } from '@/store/modules/app'
import { IMG_HOST } from '@/config/env'
import { mediaTypeOptions } from '@/constants/app'
import { debounce } from 'lodash'
import UploadImg from '@/components/upload_img/index.vue'
import LoadMoreList from '@/components/load_more_list/index.vue'

@Component({
    name: 'MediaCreate',
    components: {
        UploadImg,
        LoadMoreList
    }
})
export default class extends Vue {

    private validateScore = (rule: any, value: number, callback: Function) => {
        if (value > 1000) {
            callback(new Error('请输入正确的评分，0-1000的数字'))
        } else if (value && !isValidScore(value)) {
            callback(new Error('请输入正确的评分，最多1位小数'))
        } else {
            callback()
        }
    }

    private validateEmail = (rule: any, value: string, callback: Function) => {
        if (!value) callback()
        if (!isValidEmail(value)) {
            callback(new Error('请输入正确的Email'))
        } else {
            callback()
        }
    }

    private validateAlias(rule: any, value: string, callback: Function) {
        if (this.submitFlag) {
            callback()
        }
        if (!value) callback('请输入别名')
        callback() 
    }

    private mediaRules = {
        name: [
            { required: true, message: '请输入媒体名称', trigger: 'blur' },
            { min: 2, max: 20, message: '请输入正确的名称，2-20个字符', trigger: 'blur' }
        ],
        score: [{ validator: this.validateScore, trigger: 'blur' }],
        intro: [
            { min: 2, max: 1000, message: '请输入正确的媒体介绍，2-1000个字符', trigger: 'blur' }
        ],
        alias: [
            { validator: this.validateAlias, trigger: 'false' }
        ],
        type: [{ required: true, message: '请选择媒体属性', trigger: 'blur' }]
    }
    private focus!: boolean
    private popverWidth = ''
    private inputPopver = false
    private fetchLoading = false
    private isCreateLoading = false
    private submitFlag = false
    private pageIndex = 1
    private pageSize = 50
    private pageTotal = 0
    private suggestList: any[] = []
    private mediaMpTypes: any[] = []
    private suggestMap!: Map<any, any>
    private orgItem = { name: '', id: '' }
    private mediaForm: any = {
        name: '',
        region: '',
        score: '',
        url: '',
        address: '',
        email: '',
        phone: '',
        logo: '',
        intro: '',
        alias: '',
        aliasArr: [],
        type: '',
        mp_type_ids: [],
        media_type: -1
    }
    private mediaId = ''
    private IMG_HOST = IMG_HOST
    private typeOptions = mediaTypeOptions
    private mediaTypes: any[] = []
    private fetchSuggest = debounce(async () => {
        this._reset()
        this.fetchLoading = true
        await this.getSuggest()
        this.fetchLoading = false
    }, 300)

    get provinceAndCityData() {
        return AppModule.provinceAndCity
    }
    get mediaFormRef() {
        return this.$refs.mediaForm as ElForm
    }
    get hasMore() {
        return this.suggestList.length < this.pageTotal
    }

    async mounted() {
        this.mediaForm.media_type = this.$route.query.type === 'media' ? 0 : 1
        await this.fetchMediaTypes()
        await this.fetchmediaMpTypes()
        this.fetchRegion()
        this.calcPopverWidth()
        this.listenBodyClick()
    }

    // 媒体属性列表
    private async fetchMediaTypes() {
        const result = await MediaService.getMediaTypes()
        if (result.status === 200) {
            this.mediaTypes = result.data
        }
    }

    // 媒体形态列表
    private async fetchmediaMpTypes(params?: any) {
        const result = await MediaService.getMediaMpTypes(params)
        if (result.status === 200) {
            this.mediaMpTypes = result.data
        }
    }

    private async fetchRegion() {
        AppModule.getRegion()
    }

    private convertCodeToText(code: any) {
        let [provinceCode, cityCode] = code
        let text = ''
        if (provinceCode && CodeToText[provinceCode]) {
            const province = CodeToText[provinceCode]
            text += province
            if (cityCode && CodeToText[cityCode]) {
                const city = CodeToText[cityCode]
                text += ',' + city
            }
        }
        return text
    }

    private uploadCallback(url: string) {
        this.mediaForm.logo = url
        this.mediaFormRef.validateField('logo')
    }

    private onSelectRegion(value: any) {
        this.mediaForm.region = value
    }

    private onMediaAliasEnd() {
        this.mediaFormRef.validateField('alias')
        if (!this.mediaForm.alias) {
            return
        }
        this.mediaForm.aliasArr.push(this.mediaForm.alias)
        this.mediaForm.alias = ''
    }

    private onCloseAlias(index: number) {
        this.mediaForm.aliasArr.splice(index, 1)
    }

    private onCreateMedia() {
        this.submitFlag = true
        this.mediaFormRef.validate(async(valid: boolean) => {
            if (valid) {        
                this.submitFlag = false
                this.isCreateLoading = true
                const { name, type, mp_type_ids, region, score, url, address, email, phone, logo, 
                    intro, aliasArr, media_type } = this.mediaForm
                const params = { 
                    name: name, 
                    type: type,
                    mp_type_ids: mp_type_ids,
                    region: this.convertCodeToText(region), 
                    score: parseInt(score), 
                    url: url,
                    address: address,
                    email: email,
                    phone: phone,
                    logo: logo,
                    intro: intro,
                    alias: aliasArr || [],
                    org_id: +this.orgItem.id || undefined,
                    media_type: [-1, 0].includes(media_type) ? 'media' : 'self_media' 
                }
                const result = await MediaService.create(params)
                if (result.status === 200) {
                    this.mediaFormRef.resetFields()
                    this.mediaForm.mp_type_ids = []
                    this.$message({ type: 'success', message: '操作成功' })
                } else if (result.status === 400) {
                    this.$message({ type: 'warning', message: '数据已存在' })
                } else {
                    this.$message({ type: 'error', message: result.message })
                }
                this.isCreateLoading = false
            } else {
                return false
            }
        })
    }

    // 修改媒体形态
    // private async updateMediaMpTypes() {
    //     const params = {
    //         medium_id: parseInt(this.mediaId),
    //         mp_type_id: this.curMpTypes
    //     }
    //     const result = await MediaService.updateMediaMpTypes(params)
    //     if (result.status === 200) {
    //         this.$message({ type: 'success', message: '操作成功' })
    //     } else {
    //         this.$message({ type: 'error', message: result.message })
    //     }
    // }
    
    calcPopverWidth() {
        this.popverWidth = (this.$refs.orgInputRef as any).$el.clientWidth
    }
    onGetLoadMore() {
        this.pageIndex += 1
        this.getSuggest({ more: true })
    }
    async onInputFocus() {
        this.focus = true
        if (!this.suggestList.length) {
            this.fetchLoading = true
            await this.getSuggest()
            this.fetchLoading = false
        }
        this.inputPopver = true
    }
    onInputBlur() {
        this.focus = false
    }
    // 获取建议机构列表
    async getSuggest({ more } = { more: false }) {
        const self = this
        const params = {
            query: this.orgItem.name,
            page_index: this.pageIndex,
            page_size: this.pageSize
        }
        const result = await MediaService.getOrgList(params)
        if (result.status === 200) {
            this.pageTotal = result.data.page_total
            if (more) {
                this.suggestList = this.suggestList.concat(result.data.org_list)
                concat(result.data.org_list)
            } else {
                this.suggestList = result.data.org_list
                this.suggestMap = toNewMap(result.data.org_list)
            }
        }
        // 把数组增加到 map 里
        function concat(list: any[]) {
            list.forEach(n => {
                self.suggestMap.set(n.id, n)
            }) 
        }
        // array to map
        function toNewMap(list: any[]) {
            let map = new Map()
            list.forEach(n => {
                map.set(n.id, n)
            })
            return map
        }
    }

    listenBodyClick() {
        document.documentElement.addEventListener('click', this.closeCustomPopover)
        this.$once('hook:beforeDestroy', () => {
            document.removeEventListener('click', this.closeCustomPopover)
        })
    }
    // document 事件，关闭自定义弹出层
    closeCustomPopover(event: any) {
        if (!this.inputPopver || this.focus) return
        const { target } = event
        const popver = (this.$refs.customPopover as any).popperElm
        if (!popver) return
        const isContain = popver.contains(target)
        if (!isContain) {
            // 关闭 popver
            this.inputPopver = false
        }
    }
    // 选择建议
    onSelectSuggest(e: any) {
        const { id } = e.target.dataset
        if (!id) return
        const seletItem = this.suggestMap.get(+id)
        this.orgItem = seletItem
        this.inputPopver = false
    }
    _reset() {
        this.pageIndex = 1
        this.pageTotal = 0
        this.suggestList = []
        this.suggestMap = new Map()
    }
    onCancel() {
        this.$router.go(-1)
    }
    // formatMpTypes(mpTypes: any[]) {
    //     mpTypes.map((mpType: any) => {
    //         this.curMpTypes.push(
    //             mpType.id
    //         )
    //     })
    // }
}
